/* import api from '../_api'; */
import { SSOauth, SSOsingleUserDataRequest } from '../../../assets/requests/request';

const checkAccessToken = ({ getters }) => {
  const token = getters.accessToken;
  if (!token) {
    window.location.href = '/login';
  }
  const accessToken = { accessToken: token };
  return new Promise((resolve, reject) => {
    SSOauth.post('/check_token', accessToken).then((response) => {
      if (response.status === 200) {
        resolve(true);
      }
    }, () => {
      reject(Error('Token Invalid'));
      window.location.href = '/login';
    });
  });
};

const getAccessTokenUser = ({ commit }, userCredentials) => {
  const tokenData = {
    requestUser: userCredentials.requestUser,
    requestPassword: userCredentials.requestPassword,
    resourceIdentifier: 'dashboard',
    tokenLabel: 'dashboard-token',
  };
  const requestParams = {
    auth: {
      username: userCredentials.requestUser,
      password: userCredentials.requestPassword,
    },
  };
  return new Promise((resolve, reject) => {
    SSOauth.post('/authenticate', tokenData, requestParams).then((response) => {
      if (response.status === 200) {
        commit('updateAccessToken', response.data.token);
        commit('updateUserName', userCredentials.requestUser);
        resolve(true);
      }
    }, (error) => {
      reject(error);
    });
  });
};

const getUserData = ({ getters }) => {
  const { userName } = getters;
  const requestParams = {
    headers: { 'x-dashboard-token': getters.accessToken },
    auth: {
      username: userName,
      password: '',
    },
  };
  return new Promise((resolve, reject) => {
    SSOsingleUserDataRequest.get(`/${userName}`, requestParams).then((response) => {
      if (response.status === 200) {
        resolve(
          {
            client: response.data.response.user_group,
            display_name: response.data.response.display_name,
          },
        );
      }
    }, () => {
      reject(Error('Unable to get user data'));
    });
  });
};

const logoutUser = ({ rootGetters, commit }) => {
  commit('updateAccessToken', null);
  commit('updateUserName', null);
  commit('updateCurrentClient', null, { root: true });
  commit('updateCurrentClientDisplayName', null, { root: true });
  window.localStorage.removeItem(rootGetters.persistedStateKey);
};

export default {
  checkAccessToken,
  getAccessTokenUser,
  getUserData,
  logoutUser,
};
